import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
// import Application from '../pdf/Application.pdf';
// import Application from '../pdf/ApplicationForm.pdf'
// import Application from '../pdf/Application.pdf''
import OfferLetterpdf from '../pdf/OfferLetter.pdf'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import icon from '../All/images/tick-icon.png';
// import icon from '../All/images/tick-icon.png';
// import fs from 'fs';
import fontkit from '@pdf-lib/fontkit';  // Import fontkit for custom fonts
import poppins from '../fonts/Poppins-Regular.ttf';
import poppinsBold from '../fonts/Poppins-Bold.ttf';
import axios from '../Axiosinstance'
import { removeBracketedText } from '../Axiosinstance';

const OfferLetter = forwardRef((dataProp, ref) => {




    const handleDownload = async (studentdetails) => {
        try {

            // let coursefee;
            // let registerfee;

            // const fetchCourses = async (courseid) => {
            //     try {
            //         // const response = await axios.get(`batch/${courseid}`); // Replace with your API URL
            //         // coursefee = response.data.courseFee.toString();
            //         // registerfee = response.data.registrationFee.toString();

            //         // Fetch registration advance details using NRIC
            //         const registrationResponse = await axios.get('registrationadvances/registration/search', {
            //             params: {
            //                 nric: studentdetails.nric,
            //             },
            //         });
            //         coursefee = registrationResponse.data.courseFee.toString();
            //         registerfee = registrationResponse.data.registrationFee.toString();
            //     } catch (error) {
            //         console.error('Error fetching courses:', error);
            //     }
            // };
            // const extractNumberFromText = (text) => {
            //     const match = text.match(/\((\d+)\)/); // This regex captures digits inside parentheses
            //     return match ? match[1] : null; // Returns the number or null if no match is found
            // };

            // Extract the course ID from student details
            const courseid = studentdetails?.batch?.id;
            // Fetch course details
            // if (courseid) {
            //     await fetchCourses(courseid);
            // }

            // Ensure that coursesDetail is updated before proceeding
            // const registrationfee = coursedetail?.clustercode || '';
            // const coursefee = coursedetail?.fee || '';

            const pdfBytes = await fetch(OfferLetterpdf).then(res => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(pdfBytes);

            // Register fontkit
            pdfDoc.registerFontkit(fontkit);
            // Fetch and embed the custom Poppins font
            const poppinsFontBytes = await fetch(poppins).then(res => res.arrayBuffer());
            const poppinsFont = await pdfDoc.embedFont(poppinsFontBytes);

            pdfDoc.registerFontkit(fontkit);
            const poppinsBoldBytes = await fetch(poppinsBold).then(res => res.arrayBuffer());
            const poppinsBoldfont = await pdfDoc.embedFont(poppinsBoldBytes);


            // Set font and size
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
            // const fontbold = await pdfDoc.embedFont(StandardFonts.);

            // Access the pages
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const secondPage = pages[1];

            const fontSize = 10;

            // Data to insert
            const studentName = (studentdetails?.name || '').toUpperCase();
            const passportNo = studentdetails?.passport || '';
            // const currentDate = new Date().toISOString();
            const currentDate = studentdetails.offerDate;
            const registerfee = (studentdetails?. registrationFee?? 0).toString();
            const coursefee = (studentdetails?.courseFee ?? 0).toString();
            // const discountedcoursefee = coursefee - (discountAmount || 0);
            const address = studentdetails?.address || '';

            const wrapText = (text, maxWidth) => {
                const words = text.split(" ");
                let lines = [];
                let currentLine = words[0];

                for (let i = 1; i < words.length; i++) {
                    const word = words[i];
                    const width = font.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);

                    if (width < maxWidth) {
                        currentLine += ` ${word}`;
                    } else {
                        lines.push(currentLine);
                        currentLine = word;
                    }
                }
                lines.push(currentLine);
                return lines;
            };

            const maxWidth = 425;
            const paragraph1 =
            "I, _________________________________________ , _______________ (Passport no) accepted the offer.";
        const paragraph2 =
            "As a local student I wish to engage TIIA to be recruitment agent and support my enrolment and studies.";
        
        // Wrap each paragraph separately
        const wrappedParagraph1 = wrapText(paragraph1, maxWidth);
        const wrappedParagraph2 = wrapText(paragraph2, maxWidth);
        
        // Combine the wrapped paragraphs, adding a line break or space between them
        const wrappedText = [...wrappedParagraph1, "", ...wrappedParagraph2];


            const formatDate = (dateString) => {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                return `${day}.${month}.${year}`;
            };

            const course = removeBracketedText((studentdetails?.course || '')).toUpperCase();


            // Draw existing text on different pages

            firstPage.drawText(formatDate(currentDate), { x: 516, y: 685.5, size: 10, font: poppinsBoldfont, color: rgb(0, 0, 0), });

            firstPage.drawText(studentName, { x: 57, y: 637.5, size: 10, font: poppinsBoldfont, color: rgb(0, 0, 0), });

            firstPage.drawText(passportNo, { x: 125, y: 624, size: 10, font: poppinsBoldfont, color: rgb(0, 0, 0), });
            
            // firstPage.drawText(address, { x: 56, y: 611, size: 8, font: poppinsFont, color: rgb(0, 0, 0), });

            firstPage.drawText(studentName, { x: 88, y: 571.5, size: 10, font: poppinsBoldfont, color: rgb(0, 0, 0), });

            firstPage.drawText(course, { x: 260, y: 462, size: 10, font: poppinsBoldfont, color: rgb(1, 1, 1), });

            firstPage.drawText(registerfee, { x: 308, y: 365, size: 10, font: poppinsBoldfont, color: rgb(0, 0, 0), });

            firstPage.drawText(`${coursefee}*`, { x: 308, y: 350, size: 10, font: poppinsBoldfont, color: rgb(0, 0, 0), });

            // secondPage.drawText(wrappedText,  { x: 80, y: 600, size: 10, font: poppinsFont, color: rgb(0, 0, 0), });

            secondPage.drawText(studentName, { x: 80, y: 576, size: 10, font: poppinsBoldfont, color: rgb(0, 0, 0), });

            secondPage.drawText(passportNo, { x: 380, y: 576, size: 10, font: poppinsBoldfont, color: rgb(0, 0, 0), });

            let ywrapposition = 575;  // Initial y position
            const lineSpacing = 15;

            wrappedText.forEach((line) => {
                secondPage.drawText(line, {
                    x: 60,
                    y: ywrapposition,
                    size: fontSize,
                    font: poppinsFont,
                    color: rgb(0, 0, 0),
                });
                ywrapposition -= lineSpacing; // Adjust y position for the next line
            });


            const drawWrappedText = (page, text, xFirst, y, maxWidthFirst, xSubsequent, maxWidthSubsequent, font, fontSize, color) => {
                const lines = [];
                let currentLine = '';
                let words = text.split(' ');

                while (words.length > 0) {
                    let word = words.shift();
                    let testLine = currentLine + word + ' ';
                    let testWidth = font.widthOfTextAtSize(testLine, fontSize);

                    if (testWidth <= (lines.length === 0 ? maxWidthFirst : maxWidthSubsequent)) {
                        currentLine = testLine;
                    } else {
                        lines.push(currentLine.trim());
                        currentLine = word + ' ';
                    }
                }
                lines.push(currentLine.trim());

                // Draw lines
                lines.forEach((line, index) => {
                    page.drawText(line, {
                        x: index === 0 ? xFirst : xSubsequent,
                        y: y - (index * fontSize * 1.2),
                        size: fontSize,
                        font: font,
                        color: color
                    });
                });
            };

            drawWrappedText(firstPage, address, 56, 611, 190, 56, 190, poppinsFont, 8, rgb(0, 0, 0));



            // Save the modified PDF
            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };


    useImperativeHandle(ref, () => ({ handleDownload }));

    return null;
});

export default OfferLetter;
